import React from "react";
import { withStyles, Card, CardContent, CardActionArea } from "@material-ui/core";

const styles = theme => ({
    container:{
        borderRadius:"2px",
        backgroundColor:"transparent",
        '& $content':{
            padding:"4px 8px",
        }
    },
    zoneActive:{
       '& $content':{
           backgroundColor: theme.trailerCardSelectedColor
       }
    },
    content:{
        border:`1px solid ${theme.tooltipBGColor}`,
        color: theme.gridTextColor,
        width:"100%",
        backgroundColor: theme.gridBGColor,
        fontSize:12,
        padding:"4px 8px",
        cursor:"pointer"
    }

})

class NoFMRTZone extends React.PureComponent{
    onZoneClicked = (event) => {
        event.stopPropagation();
        if(this.props.updateFilter){
            const { zoneName , isFilteredZone, filteredProType, routeType } = this.props;
            const selectZone = filteredProType || !isFilteredZone ? zoneName : null;
            this.props.updateFilter({
                loadingZone: selectZone,
                proType: null,
                routeType: selectZone ? routeType : null
            });
        }
    }

    render(){
        const { classes, isFilteredZone } = this.props;
        const { totalBills } = this.props.data;
        return (
            <Card raised={isFilteredZone} classes={{root: `${classes.container} ${isFilteredZone ? classes.zoneActive: ""}`}}>
                <CardActionArea>
                    <CardContent classes={{root: classes.content}} onClick={this.onZoneClicked}>
                            <div>{totalBills} Bills with No FMRT</div>
                    </CardContent>
                </CardActionArea>
            </Card>
        )
    }
}


export default withStyles(styles)(NoFMRTZone)